<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import SpecialistAnimatedText from '~/components/specialist/SpecialistAnimatedText.vue'
import SpecialistHeaderItem from '~/components/specialist/SpecialistHeaderItem.vue'
import SpecialistSearch from '~/components/specialist/SpecialistSearch.vue'
import { useResponsiveScreenFacade } from '~/composables/responsive-screen-facade'
import AuthScope from '~/enums/auth-scope'
import { useSpecialistsStore } from '~/store/specialists'

const emit = defineEmits<{
  (e: 'onSearch'): void
}>()

const texts: string[] = [
  'Увеличить энергию',
  'Улучшение кожи',
  'Укрепление волос',
  'Улучшение работы иммунной системы',
  'Снижение стресса',
  'Улучшение сна',
  'Улучшение памяти и работы мозга',
  'Поддержка обмена веществ',
  'Улучшение пищеварения',
  'Защита от возрастных изменений',
  'Поддержка здоровья печени',
  'Детокс организма',
  'Лечение и профилактика анемии',
  'Балансировка гормонального фона',
]

const items = [
  { icon: 'outlined/doctor', title: '>\xA01500 квалифицированных специалистов' },
  { icon: 'outlined/time',   title: 'Подбор подходящего специалиста за\xA0пару минут' },
  { icon: 'outlined/doctor', title: 'Удобная формат записи: онлайн и\xA0офлайн' },
  { icon: 'outlined/time', title: 'Персонализированный подход к\xA0каждому клиенту' },
  { icon: 'outlined/doctor', title: 'Комплексное решение проблем' },
  { icon: 'outlined/time', title: 'Современные методы диагностики и лечения' },
  { icon: 'outlined/doctor', title: 'Постоянное обновление знаний и\xA0опыта' },
  { icon: 'outlined/time', title: 'Консультации без долгой записи и\xA0ожиданий' },
  { icon: 'outlined/doctor', title: 'Скорость получения решений и\xA0рекомендаций' },
  { icon: 'outlined/time', title: 'Простота записи и\xA0быстрота ответа' },
]

const specialistsStore = useSpecialistsStore()

const { isMd } = useResponsiveScreenFacade()

async function loadData (): Promise<void> {
  specialistsStore.page.number = 1

  emit('onSearch')

  await specialistsStore.fetchSpecialists(AuthScope.Client)
}
</script>

<template>
  <header
    class="rounded-3xl p-0 md:bg-white md:p-6 lg:p-8"
    itemscope
    itemtype="https://schema.org/WPHeader"
  >
    <div class="mx-auto mt-4 max-w-[934px] md:mt-0">
      <h1
        class="
          mb-6 min-h-[112px] text-[28px] leading-none sm:min-h-[96px]
          md:!mb-8 md:text-center md:text-[44px] md:leading-[1.09]
        "
      >
        <span class="hidden md:inline">
          Консультации со&nbsp;специалистами превентивной медицины:
        </span>
        <span class="inline md:hidden">
          Специалисты превентивной медицины
        </span>
        <SpecialistAnimatedText class="!text-main-green" :context="texts" />
      </h1>

      <div class="flex items-center">
        <SpecialistSearch class="w-full" @clear="loadData" @enter="loadData" />

        <BasicButton
          class="ml-3 !hidden !h-14 !min-w-[208px] !rounded-2xl !text-base md:!block"
          color="green"
          is-small
          :title="isMd ? 'Найти специалиста' : 'Найти'"
          @click="loadData"
        />
      </div>

      <h2
        class="mt-[28px] text-sm !font-normal md:!text-base"
        itemprop="alternativeHeadline"
      >
        <Marquee>
          <SpecialistHeaderItem
            v-for="(x, index) in items"
            :key="index"
            class="mr-4 max-w-[280px] last:mr-0"
            :icon="x.icon"
            :title="x.title"
          />
        </Marquee>
      </h2>
    </div>
  </header>
</template>
